import React from "react";
import get from "lodash/get";
import { object, bool, number, string } from "prop-types";

import { getHeadline, getExcerpt, checkCurrentStoryTagForSpecialCampaign } from "../../utils/utils";

import NewsHeadline from "../../atoms/NewsHeadline";
import Excerpt from "../../atoms/Excerpt";
import SectionHolder from "../../atoms/SectionHolder";
import LiveNewsHeadline from "../../atoms/liveNewsHeadline";
import SponsorDetails from "../../molecules/SponsorDetails";

const NewsWithNoImage = ({
  story,
  sectionData,
  showSectionTag,
  datatrackinglabelpos,
  selectedTagName,
  headlineSpecialColor,
  showExcerpt = true,
  showDot = false,
  styles = {},
  showSubHeading = true,
}) => {
  const { subheadline } = story;
  const storyHeadline = getHeadline(story);
  const excerpt = getExcerpt(story);
  const currentStoryTitleColor = checkCurrentStoryTagForSpecialCampaign(story, selectedTagName, headlineSpecialColor);
  const showLiveBlog = story["story-template"] === "live-blog";
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  return (
    <div className="news_with_no_image">
      {showLiveBlog ? (
        <LiveNewsHeadline
          titleText={storyHeadline}
          titleLink={story.url}
          story={story}
          cssStyleName="mediumSize"
          datatrackingcategory="Component One"
          datatrackingaction="Click"
          datatrackinglabel={`Position-${datatrackinglabelpos}`}
          datatrackingsubcategory="Component One Story Click"
        />
      ) : (
        <NewsHeadline
          story={story}
          titleText={storyHeadline}
          titleLink={story.url}
          subHeadlineText={subheadline}
          cssStyleName="mediumSize"
          datatrackingcategory="Component One"
          datatrackingaction="Click"
          datatrackinglabel={`Position-${datatrackinglabelpos}`}
          datatrackingsubcategory="Component One Story Click"
          currentStoryTitleColor={currentStoryTitleColor}
          showDot={showDot}
          styles={styles}
          showSubHeading={showSubHeading}
        />
      )}
      {showExcerpt && (
        <Excerpt
          excerpt={excerpt}
          excerptLink={story.url}
          datatrackingcategory="Component One"
          datatrackingaction="Click"
          datatrackinglabel={`Position-${datatrackinglabelpos}`}
          datatrackingsubcategory="Component One Story Click"
        />
      )}
      {sponsorId ? (
        <SponsorDetails sponsorId={sponsorId} showImage={false} />
      ) : sectionData ? (
        <SectionHolder sectionData={sectionData} story={story} showSectionTag={showSectionTag} />
      ) : null}
    </div>
  );
};

NewsWithNoImage.propTypes = {
  story: object.isRequired,
  sectionData: object,
  showSectionTag: bool,
  datatrackinglabelpos: number,
  selectedTagName: string,
  headlineSpecialColor: string,
  NewsWithImage: bool,
  showExcerpt: bool,
  showDot: bool,
  styles: object,
  showSubHeading: bool,
};

export default NewsWithNoImage;
